const config = window.APP_CONFIG;

const emailTemplatesNL = [
  // 0. CEO Fraud (leeg)
  {
    id: 0,
    language: "nl",
    subject: "Snelle reactie",
    body: `<p>Hallo {{nickname}}</p><p>Ik zit momenteel in een vergadering en heb je nodig om nu een snelle taak voor me uit te voeren. Stuur me je WhatsApp-nummer en wacht op mijn bericht.</p>
    <p class="pt-4">Met vriendelijke groet,</p><p>${config.CEO}</p>`,
    sender: `<p class="malicious" title="Dit lijkt een persoonlijk Gmail-adres te zijn van een individu. Vermoedelijk is het account gehackt en is de naam aangepast naar die van jouw CEO">${config.CEO} &lt;alainhenrard76@gmail.com&gt;</p>`,
    isPhishing: true,
    footer: ``
  },

  // 1. Security Mail – verdachte login
  {
    id: 1,
    language: "nl",
    subject: "Ongebruikelijke aanmeldingsactiviteit gedetecteerd",
    body: `
    <div style="text-align:center;">
      <img src="/images/microsoft.png" alt="Microsoft logo" style="display:block; margin: 0 auto; height: 150px;" />

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        We hebben een poging tot aanmelden op je Microsoft-account opgemerkt vanaf een nieuw apparaat of locatie.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        We raden je aan je accountinstellingen onmiddellijk te controleren.
      </p>

      <div style="margin: 24px 0;">
        <a
          href="https://micr0s0ft.com/login"
          class="malicious"
          title="Opgelet: verdacht domein"
          style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;font-weight:bold;"
        >
          Controleer activiteit
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Activiteit gedetecteerd: 05 juni 2025 om 10:42 (CET)</p>
    </div>
  `,
    sender: `<p class="malicious" title="Verdachte afzender met lookalike domein">Microsoft Beveiliging &lt;security@micr0s0ft.com&gt;</p>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Deze e-mail is automatisch gegenereerd. Reageer niet rechtstreeks op dit bericht.<br />
      Bezoek je <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">beveiligingsinstellingen</a> voor meer informatie.
    </div>
  `
  },

  // 4. IT – software update
  {
    id: 4,
    language: "nl",
    subject: "Belangrijke beveiligingsupdate vereist – vandaag uitvoeren",
    body: `
    <div style="text-align:center;">
      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Goedemorgen {{nickname}},</p>

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        Er is een belangrijke beveiligingsupdate beschikbaar voor jouw werkstation. Om risico’s te beperken, vragen we om deze vandaag nog uit te voeren.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Klik op onderstaande knop om de update direct te starten.
      </p>

<div style="margin: 24px 0;">
  <a
    href="https://${config.companyDomainPhishing}/update"
    class="malicious"
    title="Domein komt niet overeen met je organisatie"
    style="
      background:#ffc107;
      color:black;
      padding:12px 20px;
      border-radius:4px;
      font-weight:bold;
    "
  >
    Start update
  </a>
</div>


      <p style="font-size:13px; color:#666;">
  Update-ID: KB509821 — beschikbaar sinds ${new Date().toLocaleDateString('nl-BE')}
</p>

    </div>
  `,
    sender: `<p class="malicious" title="Afzenderdomein wijkt af van intern IT-beheer">IT Beheer &lt;it@${config.companyDomainPhishing}&gt;</p>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Heb je vragen? Contacteer <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
      Deze melding werd automatisch verstuurd vanuit het IT-beheersysteem.
    </div>
  `
  }
  ,

  // 5. Account Notification – nieuwe melding
  {
    id: 5,
    language: "nl",
    subject: "Er is gereageerd op je bijdrage",
    body: `<div style="text-align:center;">

  <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
  <p style="font-size:15px; line-height:1.6;">Iemand heeft zojuist een reactie geplaatst op een van je recente bijdragen.</p>
  <p style="font-size:15px; line-height:1.6;">Bekijk de reactie en start het gesprek.</p>

  <div class="relative group" style="margin: 20px 0; display: inline-block;">
    <a
      href="https://www.Iinkedin/activity/post/8394"
      class="malicious"
      style="background:#0077b5; color:white; padding:10px 20px; border-radius:4px; display:inline-block; font-weight:bold;"
    >
      Bekijk activiteit
    </a>

    <!-- Custom tooltip -->
    <div
      class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
    >
      Opgelet: Afzender lijkt op linkedin.com maar is eigenlijk Iinkedin.com.<br />Dit kon je zien door over de knop te hoveren.
    </div>
  </div>
</div>
`,
    sender: `
  <span class="relative group inline-block">
    <span style="font-family: monospace;" class="malicious">
      LinkedIn Meldingen &lt;noreply@Iinkedin.com&gt;
    </span>
    <div
      class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
    >
      Afzender lijkt op linkedin.com maar is eigenlijk Iinkedin.com.<br />
      Dit kon je zien door over het domein te hoveren.
    </div>
  </span>
`,

    isPhishing: true,
    footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
    Je ontvangt deze melding op basis van je notificatie-instellingen.<br />
    <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Beheer je instellingen</a>
  </div>`
  },



  // 7. Social Media – Facebook melding
  {
    id: 7,
    language: "nl",
    subject: "Je hebt een nieuwe reactie op je bericht",
    body: `
    <div style="text-align:center;">

      <img src="/images/fb.svg" alt="Facebook logo" style="display:block; margin: 0 auto 16px; height:40px;" />

      <p style="font-size:15px; color:#333; line-height:1.6;">
        Iemand heeft gereageerd op een van je recente berichten op Facebook.
      </p>

      <p style="font-size:15px; color:#333; line-height:1.6;">
        Bekijk de reactie en blijf op de hoogte van het gesprek.
      </p>

      <div style="margin: 20px 0;">
<div class="relative inline-block group mt-4">
  <a
    href="https://facebook-alerts.com/meldingen"
    class="malicious"
    title="Deze knop verwijst naar een niet-officiële Facebook URL"
    style="background:#1877f2; color:white; padding:12px 20px; border-radius:4px; font-weight:bold; display:inline-block;"
  >
    Naar je melding
  </a>
  <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-full bg-red-600 rounded"></div>
</div>

      </div>
    </div>
  `,
    sender: `<p class="malicious" title="Vervalst e-mailadres, dit is geen geldig domein van facebook">Facebook Meldingen &lt;no-reply@facebook-alerts.com&gt;</p>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
      Deze melding werd verstuurd naar jouw accountinstellingen.<br />
      Facebook vraagt je nooit om persoonlijke gegevens via e-mail.<br />
     <p href="https://facebook-alerts.com/meldingen" class="malicious" title="Niet-officiële Facebook URL">Naar je melding</p>
    </div>
  `
  }
  ,
  // 9. Energy – Eneco factuur (QR code)
  {
    id: 9,
    language: "nl",
    subject: "Je Eneco-factuur van deze maand is beschikbaar",
    body: `
    <div style="text-align:center;">

      <img src="/images/Eneco.png" alt="Eneco logo" style="display:block; margin: 0 auto; height: 150px;" />

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je nieuwe energiefactuur is beschikbaar in je klantenportaal.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Je kunt deze snel en veilig betalen via onderstaande QR-code.
      </p>

      <div style="margin: 24px 0;" class="group relative inline-block">
  <img
    src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150"
    class="malicious"
    title="QR-code verwijst naar een domein dat niet officeel van eneco is"
    style="display:block; margin: 0 auto;"
  />
  <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-[150px] bg-red-600 rounded"></div>
</div>

      <p style="font-size:13px; color:#666;">Factuurnummer: ENE-202406-8127</p>
    </div>
  `,
    sender: `<p class="malicious" title="Domein is geen officieel domain van Eneco">Eneco België &lt;facturen@eneco-facturatie.be&gt;</p>`,
    isPhishing: true,
    footer: `
  `
  }

];

export default emailTemplatesNL;
